import { useEffect, useState } from "react";
import { MailPlus } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { fmtDate } from "../lib/roles";
import { Button } from "./ui/button";
import { Checkbox } from "./ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const STATUS = { pronta: ["Password scelta", "bg-emerald-50 text-emerald-700"], invitato: ["Invitato, in attesa", "bg-amber-50 text-amber-700"], da_invitare: ["Da invitare", "bg-slate-100 text-slate-600"] };

const Summary = ({ list }) => (
  <div className="flex flex-wrap gap-2 text-xs" data-testid="first-password-summary">{Object.entries(STATUS).map(([k, [l, c]]) => (
    <span key={k} className={`px-2.5 py-1 rounded-full font-semibold ${c}`} data-testid={`first-password-count-${k}`}>{l}: {list.filter((u) => u.status === k).length}</span>))}
  </div>
);

export function FirstPasswordDialog() {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState(null);
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(0);
  useEffect(() => {
    if (!open) return;
    setList(null);
    api("/web/first-password/pending").then((d) => { setList(d.users || []); setSel((d.users || []).filter((u) => u.status === "da_invitare").map((u) => u.id)); }).catch((e) => { toast.error(e.message); setList([]); });
  }, [open]);
  const send = async () => {
    if (!sel.length) return toast.error("Seleziona almeno un dipendente");
    if (!window.confirm(`Inviare l'email per scegliere la password a ${sel.length} dipendenti?\n\nLa password che sceglieranno varrà anche per l'app mobile.`)) return;
    setBusy(true); setDone(0);
    const failed = [];
    let sent = 0;
    for (const id of sel) {
      try { await api(`/web/first-password/send/${id}`, { method: "POST" }); sent += 1; } catch (e) { failed.push(e.message); }
      setDone((n) => n + 1);
    }
    toast.success(`Email inviate: ${sent}`);
    if (failed.length) toast.error(`Non inviate: ${failed.length} (${failed[0]})`);
    setBusy(false);
    setOpen(false);
  };
  const toggle = (id, v) => setSel(v ? [...sel, id] : sel.filter((x) => x !== id));
  return (
    <>
      <Button variant="outline" className="rounded-full" onClick={() => setOpen(true)} data-testid="first-password-open"><MailPlus className="w-4 h-4 mr-1" />Email prima password</Button>
      <Dialog open={open} onOpenChange={(v) => !busy && setOpen(v)}>
        <DialogContent className="max-w-lg">
          <DialogHeader><DialogTitle>Email prima password</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">Stato della password per la web app di ogni dipendente. Chi riceve l'email sceglie la password con il link: quella attuale resta valida finché non la cambia.</p>
          {list && list.length > 0 && <Summary list={list} />}
          {!list ? <p className="text-sm text-slate-500">Caricamento...</p> : list.length === 0 ? <p className="text-sm text-slate-500" data-testid="first-password-empty">Nessun dipendente attivo con email.</p> : (
            <div className="max-h-80 overflow-y-auto divide-y border rounded-xl" data-testid="first-password-list">{list.map((u) => (
              <label key={u.id} className={`flex items-center gap-3 px-3 py-2 text-sm ${u.status === "pronta" ? "opacity-70" : "cursor-pointer"}`} data-testid={`first-password-row-${u.id}`}>
                <Checkbox checked={sel.includes(u.id)} disabled={u.status === "pronta"} onCheckedChange={(v) => toggle(u.id, v)} data-testid={`first-password-check-${u.id}`} />
                <span className="flex-1"><b className="text-[var(--navy)]">{u.cognome} {u.nome}</b><span className="block text-xs text-slate-500">{u.email}{u.status === "pronta" && u.password_at ? ` · scelta il ${fmtDate(u.password_at)}` : u.invited_at ? ` · invitato il ${fmtDate(u.invited_at)}` : ""}</span></span>
                <span className={`text-[11px] px-2 py-0.5 rounded-full font-semibold whitespace-nowrap ${STATUS[u.status][1]}`} data-testid={`first-password-status-${u.id}`}>{STATUS[u.status][0]}</span>
              </label>))}
            </div>)}
          <Button onClick={send} disabled={busy || !sel.length} className="rounded-full bg-[var(--teal)]" data-testid="first-password-send">{busy ? `Invio in corso... ${done}/${sel.length}` : `Invia a ${sel.length} dipendenti`}</Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
